import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@mui/material';
import {
  InsuranceParameters,
  Offers,
  SetInsuranceParameters,
} from '../../../types';
import { InsuranceContext } from '../../../context/insuranceContext';

import { moneyFormatterMDL } from '../../../helpers/moneyFormatted';
import { useNavigate } from 'react-router-dom';
import { ContinueWrapper, AmountWrapper, AmountText, ButtonWrapper } from '../styles';

const ContinueButton: React.FC<{
  parameters: InsuranceParameters;
  setInsuranceParameters: SetInsuranceParameters;
  selectedOffer: Array<Offers>;
  disabledButton: boolean;
}> = ({ parameters, selectedOffer, disabledButton }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const sum = selectedOffer?.[0]?.amount?.mdl || 0;
  const eur = selectedOffer?.[0]?.amount?.eur || 0;
  const { insurance, setInsurance } = useContext(InsuranceContext); 

  const handleNavigate = () => {
    setInsurance({
      ...insurance,
      details: {
        ...insurance.details,
        sum_mdl: sum,
        sum_eur: eur
      }
    });
    
    navigate('/confirm-data', { state: parameters });
  };

  return (
    <ContinueWrapper>
      <AmountWrapper>
        <AmountText>{`${t('total')}: ${moneyFormatterMDL.format(
          sum
        )}`}</AmountText>
      </AmountWrapper>
      <ButtonWrapper>
        <Button
          onClick={handleNavigate} 
          variant='contained'
          disabled={disabledButton}
        >
          {t('continue')}
        </Button>
      </ButtonWrapper>
    </ContinueWrapper>
  );
};

export default ContinueButton;
